import { isMockServices } from 'src/utils';
import mock from '../utils/mock';
import { UserTask } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface CreateUserTaskParams {
  name: string;
  description?: string;
  loanId: string;
  status?: string;
  priority?: string;
  assignedToUserId?: string;
  targetCompletionDate?: Date | null;
  comment?: string;
  taskType?: string;
}

export interface CreateUserTaskResponse {
  success: boolean;
  userTask: UserTask;
}

const mockCreateUserTaskResponse: CreateUserTaskResponse = {
  success: true,
  userTask: {
    id: 'mock-task-id',
    name: 'Mock Task',
    status: 'open',
    priority: 'low',
    createdAt: new Date(),
    updatedAt: new Date(),
    isDeleted: false,
  },
};

const createUserTask = async (
  args: CreateUserTaskParams,
): Promise<CreateUserTaskResponse> => {
  if (isMockServices()) {
    return await mock(mockCreateUserTaskResponse, {
      delay: 1000,
      failureRate: 0,
    });
  }

  const { targetCompletionDate, ...restData } = args;

  const requestBody = {
    ...restData,
    ...(targetCompletionDate && {
      targetCompletionDate: targetCompletionDate.toISOString(),
    }),
  };

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<CreateUserTaskResponse>(`/userTasks`, {
    method: 'POST',
    body: requestBody,
  });

  if (response.data) return response.data;

  throw new Error('Failed to create user task');
};

export default createUserTask;
